import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {useMemo, useState} from "react";
import {initialResourceItemCount} from "../utils/helpers";
import {ArticlesGuidesModel} from "../models/view/articlesGuidesModel";

export const useArticlesGuidesQuery = () => {
    const {model: {correspondence: {articles, guides}}} = useProductDetailsQuery();
    const [showCount, setShowCount] = useState<number>(initialResourceItemCount);

    const {
        title,
        resources,
        resourceCount,
        hasResources
    } = useMemo(() => {
        return new ArticlesGuidesModel(articles, guides);
    }, [articles, guides]);

    return {
        title,
        hasResources,
        resourceCount,
        resources: resources.slice(0, showCount),
        moreToShow: resourceCount > showCount,
        showAll: () => setShowCount(resourceCount)
    }
}